import API from 'services/API';

export default function sendVerificationEmail() {
  return API.request({
    method: 'POST',
    url: '/profile/sendVerificationEmail',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}
